import { HeartIcon, MicrophoneIcon, SparklesIcon, UsersIcon } from '@heroicons/react/24/outline'

const iconStyle = { width: 26, height: 26 }

const STATS = [
	{ Icon: UsersIcon, value: '300+', label: 'utställare' },
	{ Icon: MicrophoneIcon, value: '100+', label: 'föredrag och workshops' },
	{ Icon: HeartIcon, value: '100+', label: 'behandlingar och prova-på' },
	{ Icon: SparklesIcon, value: '30 år', label: 'av inspiration' },
]

const StatsRow = () => (
	<div className='hx-wrap hx-section'>
		<ul className='hx-stats'>
			{STATS.map(({ Icon, value, label }) => (
				<li key={label} className='hx-stat'>
					<div className='hx-stat__icon'>
						<Icon style={iconStyle} aria-hidden='true' />
					</div>
					<div className='hx-stat__value'>{value}</div>
					<div className='hx-stat__label'>{label}</div>
				</li>
			))}
		</ul>
	</div>
)

export default StatsRow
